export default {"src":"/_next/static/media/bela.cb99d1fd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};